import React, { useState } from "react"
import PropTypes from "prop-types"
import api from "helpers/Api"
import { isEmpty } from "lodash"
import moment from "moment"

const ProductTableComponent = ({ data, name, statusPayload, dateFormat }) => {
  const tableStyle = {
    border: "1.5px solid rgb(228, 225, 225)",
    borderCollapse: "collapse",
    borderRadius: "4px",
    marginTop: "20px",
    marginLeft: "20px", // Add left margin
    marginRight: "20px", // Add right margin
    // overflowX: "auto",
  }

  const thStyle = {
    border: "1.5px solid rgb(228, 225, 225)",
    borderCollapse: "collapse",
    backgroundColor: "#f2f3f3",
    padding: "17px",
    fontSize: "14px",
    width: "150px",
  }

  const tdStyle = {
    border: "1.5px solid rgb(228, 225, 225)",
    borderCollapse: "collapse",
    padding: "15px 20px",
  }

  const [btnLoader, setBtnLoader] = useState(false)
  
  const [tableData, setTableData] = useState(data) // Full table data
  const itemsPerPage = 50 // Items to display per page
  const [currentPage, setCurrentPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState("") // Search input
  const [filteredData, setFilteredData] = useState(data) // Holds filtered results
  const [isLoading, setIsLoading] = useState(false)
  // Handle search
  const handleSearch = () => {
    const lowerCaseSearchTerm = searchTerm.toLowerCase()

    const filtered = tableData.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(lowerCaseSearchTerm)
      )
    )

    setFilteredData(filtered)
    setCurrentPage(1) // Reset to the first page on search
  }

  // Calculate current page data
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage

  // Paginate filteredData
  const currentPageData =
    filteredData.slice(startIndex, endIndex)

  // Handle page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const totalPages = Math.ceil(filteredData.length / itemsPerPage)

  // Pagination buttons
  const renderPaginationButtons = () => {
    const buttons = []
    const displayPages = 5 // Number of buttons to display
    const start = Math.max(1, currentPage - Math.floor(displayPages / 2))
    const end = Math.min(start + displayPages - 1, totalPages)

    for (let i = start; i <= end; i++) {
      buttons.push(
        <button
          key={i}
          style={{
            backgroundColor: currentPage === i ? "#E40D8C" : "#FFFFFF",
            color: currentPage === i ? "white" : "#74788D",
            border: currentPage === i ? "1px solid #E40D8C" : "1px solid #74788D",
            padding: "5px 10px",
            marginRight: "5px",
            cursor: "pointer",
          }}
          onClick={() => handlePageChange(i)}
          disabled={currentPage === i}
        >
          {i}
        </button>
      )
    }
    return buttons
  }

  const downloadFile = ({ csvdata, fileName, fileType }) => {
    const blob = new Blob([csvdata], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  const downloadCsv = () => {
    setIsLoading(true)

    const ExportDataTable =
      filteredData.length > 0
        ? filteredData.map((item, index) => {
          const lastAssignedDate =
            name == "PL PENDING" && !isEmpty(item.assignCRMDate)
              ? item.assignCRMDate
              : name == "EW PENDING" && !isEmpty(item.assignTeamLeadDate)
                ? item.assignTeamLeadDate
                : name == "EW QUEUE" && !isEmpty(item.assignEmpDate)
                  ? item.assignEmpDate
                  : name == "EW INPROGRESS" && !isEmpty(item.subStatusDate)
                    ? item.subStatusDate
                    : item.processDate
          const cpRemarks = !isEmpty(item.cpRemarks)
            ? item.cpRemarks.replace(/[\r\n,.]/gm, "")
            : "--"
          const eventNameList = !isEmpty(item.eventName)
            ? item.eventName.map((m) => m).join(",")
            : "--"
          const eventName = JSON.stringify(eventNameList).replace(
            /","/g,
            "\n"
          )
          const eventDateList =
            item && item.eventDate && item.eventDate.length > 0
              ? item.eventDate
                .map((m) => moment(m).format(dateFormat))
                .join(",")
              : "--"
          const eventDate = JSON.stringify(eventDateList).replace(
            /","/g,
            "\n"
          )
          const remarks = !isEmpty(item.remarks)
            ? JSON.stringify(item.remarks).replace(/","/g, "\n")
            : ""
            const assignTeamEmpName = !isEmpty(item.assignTeamEmpName)
            ? JSON.stringify(item.assignTeamEmpName).replace(/","/g, "\n")
            : ""
          return {
            _id: index,
            sNo: index + 1,
            leadNo: item.leadNo ? item.leadNo : "--",
            clientCode: item.clientCode ? item.clientCode : "--",
            clientName: item.clientName ? item.clientName : "--",
            cpRemarks: cpRemarks,
            cpStatus: item.cpStatus ? item.cpStatus : "--",
            groomName: item.groomName ? item.groomName : "--",
            brideName: item.brideName ? item.brideName : "--",
            crmName: item.assignCRMEmpName ? item.assignCRMEmpName : "--",
            assignEmpName: item.assignEmpName ? item.assignEmpName : "--",
            assignTeamEmpName: assignTeamEmpName || "--",
            //  assignedDate: item.assignedDate ? item.assignedDate : "--",
            productName: item.productName ? item.productName : "--",
            // count: item.count ? item.count : "--",
            // eventName: item.eventName ? item.eventName : "--",
            subStatus: item.subStatus ? item.subStatus : "--",
            deliverableStatus: item.productioProcessStatusName
              ? item.productioProcessStatusName
              : "--",
            eventName: eventName,
            eventDate: eventDate,
            remarks: remarks,
            assignDate: !isEmpty(lastAssignedDate)
              ? moment(lastAssignedDate).format(dateFormat)
              : "--",
            dataCopyStatusName: item.dataCopyStatusName ? item.dataCopyStatusName : "--",
            dataCopiedOn: item.dataCopiedOn ? moment(item.dataCopiedOn).format(dateFormat) : "--",
            eta: item.tat ? moment(item.tat).format(dateFormat) : "--"
          }
        })
        : []
    setTimeout(() => {
      if (

        name == "NOT APPLICABLE" ||
        name == "CLIENT REWORK" ||
        name == "ON HOLD"
      ) {
        let headerData = [
          `S.No,Lead No,Client Code,Client Name,CP Remarks,CP Status,Event Name,Event Date,Groom Name,Bride Name,CRM Name,Product Lead Name,Team Name,Product Name,Sub Status,Last Assigned Date,Remarks,Deliverable Status,Data Copy Status,Copied Date`,
        ]
        let usersCsv = ExportDataTable.reduce((acc, user) => {
          const {
            sNo,
            leadNo,
            clientCode,
            clientName,
            cpRemarks,
            cpStatus,
            eventName,
            eventDate,
            groomName,
            brideName,
            crmName,
            assignTeamEmpName,
            assignEmpName,
            productName,
            subStatus,
            assignDate,
            remarks,
            deliverableStatus,
            dataCopyStatusName,
            dataCopiedOn
          } = user
          acc.push([
            sNo,
            leadNo,
            clientCode,
            clientName,
            cpRemarks,
            cpStatus,
            eventName,
            eventDate,
            groomName,
            brideName,
            crmName,
            assignTeamEmpName,
            assignEmpName,
            productName,
            subStatus,
            assignDate,
            remarks,
            deliverableStatus,
            dataCopyStatusName,
            dataCopiedOn
          ])

          return acc
        }, [])
        downloadFile({
          csvdata: [...headerData, ...usersCsv].join("\n"),
          fileName: "ProductStatusReportCount.csv",
          fileType: "text/csv",
        })
        setIsLoading(false)
      }
      else if (name == "CLIENT CHANGES") {
        let headerData = [
          `S.No,Lead No,Client Code,Client Name,CP Remarks,CP Status,Event Name,Event Date,Groom Name,Bride Name,CRM Name,Product Lead Name,Team Name,Product Name,Sub Status,Last Assigned Date,ETA Date,Remarks,Deliverable Status,Data Copy Status,Copied Date`,
        ]
        let usersCsv = ExportDataTable.reduce((acc, user) => {
          const {
            sNo,
            leadNo,
            clientCode,
            clientName,
            cpRemarks,
            cpStatus,
            eventName,
            eventDate,
            groomName,
            brideName,
            crmName,
            assignTeamEmpName,
            assignEmpName,
            productName,
            subStatus,
            assignDate,
            eta,
            remarks,
            deliverableStatus,
            dataCopyStatusName,
            dataCopiedOn
          } = user
          acc.push([
            sNo,
            leadNo,
            clientCode,
            clientName,
            cpRemarks,
            cpStatus,
            eventName,
            eventDate,
            groomName,
            brideName,
            crmName,
            assignTeamEmpName,
            assignEmpName,
            productName,
            subStatus,
            assignDate,
            eta,
            remarks,
            deliverableStatus,
            dataCopyStatusName,
            dataCopiedOn
          ])

          return acc
        }, [])
        downloadFile({
          csvdata: [...headerData, ...usersCsv].join("\n"),
          fileName: "ProductStatusReportCount.csv",
          fileType: "text/csv",
        })
        setIsLoading(false)
      }
      else if (name == "EW QUEUE") {
        let headerData = [
          `S.No,Lead No,Client Code,Client Name,CP Remarks,CP Status,Event Name,Event Date,Groom Name,Bride Name,CRM Name,Product Lead Name,Team Name,Product Name,Sub Status,Last Assigned Date,ETA Date,Deliverable Status,Data Copy Status,Copied Date`,
        ]
        let usersCsv = ExportDataTable.reduce((acc, user) => {
          const {
            sNo,
            leadNo,
            clientCode,
            clientName,
            cpRemarks,
            cpStatus,
            eventName,
            eventDate,
            groomName,
            brideName,
            crmName,
            assignTeamEmpName,
            assignEmpName,
            productName,
            subStatus,
            assignDate,
            eta,
            deliverableStatus,
            dataCopyStatusName,
            dataCopiedOn
          } = user
          acc.push([
            sNo,
            leadNo,
            clientCode,
            clientName,
            cpRemarks,
            cpStatus,
            eventName,
            eventDate,
            groomName,
            brideName,
            crmName,
            assignTeamEmpName,
            assignEmpName,
            productName,
            subStatus,
            assignDate,
            eta,
            deliverableStatus,
            dataCopyStatusName,
            dataCopiedOn
          ])

          return acc
        }, [])
        downloadFile({
          csvdata: [...headerData, ...usersCsv].join("\n"),
          fileName: "ProductStatusReportCount.csv",
          fileType: "text/csv",
        })
        setIsLoading(false)
      }
      else {
        let headerData = [
          `S.No,Lead No,Client Code,Client Name,CP Remarks,CP Status,Event Name,Event Date,Groom Name,Bride Name,CRM Name,Product Lead Name,Team Name,Product Name,Sub Status,Last Assigned Date,Deliverable Status,Data Copy Status,Copied Date`,
        ]
        let usersCsv = ExportDataTable.reduce((acc, user) => {
          const {
            sNo,
            leadNo,
            clientCode,
            clientName,
            cpRemarks,
            cpStatus,
            eventName,
            eventDate,
            groomName,
            brideName,
            crmName,
            assignTeamEmpName,
            assignEmpName,
            productName,
            subStatus,
            assignDate,
            deliverableStatus,
            dataCopyStatusName,
            dataCopiedOn
          } = user
          acc.push([
            sNo,
            leadNo,
            clientCode,
            clientName,
            cpRemarks,
            cpStatus,
            eventName,
            eventDate,
            groomName,
            brideName,
            crmName,
            assignTeamEmpName,
            assignEmpName,
            productName,
            subStatus,
            assignDate,
            deliverableStatus,
            dataCopyStatusName,
            dataCopiedOn
          ])

          return acc
        }, [])
        downloadFile({
          csvdata: [...headerData, ...usersCsv].join("\n"),
          fileName: "ProductStatusReportCount.csv",
          fileType: "text/csv",
        })
        setIsLoading(false)
      }
    }, 500)

  }
  const [assignData, setAssignData] = useState({
    assignFromDate: "",
    assignToDate: "",
    tatFromDate: "",
    tatToDate: ""
  })
  const handleChange = (e) => {
    setAssignData({ ...assignData, [e.target.name]: e.target.value })
  }
  const resetForm = () => {
    setAssignData({
      assignFromDate: "",
      assignToDate: "",
      tatFromDate: "",
      tatToDate: ""
    })
    setSearchTerm("")
    setFilteredData(data)
    setTableData(data)
  }

  // apply filter
  const applyFilter = () => {
    setBtnLoader(true)
    var searchFromDate =
      assignData && assignData.assignFromDate
        ? moment(assignData.assignFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      assignData && assignData.assignToDate
        ? moment(assignData.assignToDate).format("YYYY-MM-DD")
        : ""
    var searchTatFromDate =
      assignData && assignData.tatFromDate
        ? moment(assignData.tatFromDate).format("YYYY-MM-DD")
        : ""
    var searchTatToDate =
      assignData && assignData.tatToDate
        ? moment(assignData.tatToDate).format("YYYY-MM-DD")
        : ""
    //clientpending album 2
    var searchvalue = {}

    if (searchFromDate) {
      searchvalue.assignedFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.assignedToDate = searchToDate
    }
    if (searchTatFromDate) {
      searchvalue.tatFromDate = searchTatFromDate
    }
    if (searchTatToDate) {
      searchvalue.tatToDate = searchTatToDate
    }
    searchvalue = { ...searchvalue, ...statusPayload }

    api.post(`/get_Production_Deliverable_processStatus_new`, searchvalue)
      .then((response) => {
        const statusData = !isEmpty(response.data.data) ? response.data.data : []

        setTableData(statusData)
        setFilteredData(statusData)
        setBtnLoader(false)

      })
      .catch((error) => {
        Promise.reject(error)

      })


  }
  return (
    <div style={{ overflowX: "auto" }}>
      <div className="container">
        <h5 style={{ marginTop: "20px", color: "#495057", fontSize: "18px" }}>
          {name}
        </h5>
        {/* <div style={{ display: "flex", marginTop: "15px", padding: "25px" }}>
          <div style={{ flex: "0 0 25%", marginRight: "40px" }}>
            <div style={{ fontWeight: "bold" }}>Assign From Date</div>
            <input
              type="date"
              name="assignFromDate"
              value={assignData.assignFromDate}
              max={assignData.assignToDate}
              onChange={(e) => handleChange(e)}
              style={{ width: "100%", padding: "10px", marginTop: "5px" }}
            />
          </div>
          <div style={{ flex: "0 0 25%" }}>
            <div style={{ fontWeight: "bold" }}>Assign To Date</div>
            <input
              type="date"
              name="assignToDate"
              value={assignData.assignToDate}
              min={assignData.assignFromDate}
              onChange={(e) => handleChange(e)}
              style={{ width: "100%", padding: "10px", marginTop: "5px" }}
            />
          </div>
          <div style={{ flex: "0 0 25%" }}>
            <div style={{ fontWeight: "bold" }}>Tat From Date</div>
            <input
              type="date"
              name="tatFromDate"
              value={assignData.tatFromDate}
              max ={assignData.tatToDate}
              onChange={(e) => handleChange(e)}
              style={{ width: "100%", padding: "10px", marginTop: "5px" }}
            />

          </div>
          <div style={{ flex: "0 0 25%" }}>
            <div style={{ fontWeight: "bold" }}>Tat To Date</div>
            <input
              type="date"
              name="tatToDate"
              value={assignData.tatToDate}
              min={assignData.tatFromDate}
              onChange={(e) => handleChange(e)}
              style={{ width: "100%", padding: "10px", marginTop: "5px" }}
            />
          </div>
        </div> */}

        <div style={{ display: "flex", gap: "20px", marginTop: "15px", padding: "25px" }}>
          {[
            { label: "Assign From Date", name: "assignFromDate", value: assignData.assignFromDate, max: assignData.assignToDate },
            { label: "Assign To Date", name: "assignToDate", value: assignData.assignToDate, min: assignData.assignFromDate },
            { label: "Tat From Date", name: "tatFromDate", value: assignData.tatFromDate, max: assignData.tatToDate },
            { label: "Tat To Date", name: "tatToDate", value: assignData.tatToDate, min: assignData.tatFromDate }
          ].map((input, index) => (
            <div key={index} style={{ flex: 1 }}>
              <div style={{ fontWeight: "bold" }}>{input.label}</div>
              <input
                type="date"
                name={input.name}
                value={input.value}
                min={input.min}
                max={input.max}
                onChange={(e) => handleChange(e)}
                style={{ width: "100%", padding: "10px", marginTop: "5px" }}
              />
            </div>
          ))}
        </div>


        <div style={{ marginTop: "30px", textAlign: "right" }}>
          <button
            type="button"
            onClick={resetForm}
            style={{
              backgroundColor: "#dc3545",
              color: "#fff",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              marginRight: "15px",
              cursor: "pointer",
            }}
          >
            Reset
          </button>
          <button
            type="submit"
            onClick={applyFilter}
            style={{
              backgroundColor: "#28a745",
              color: "#fff",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {btnLoader ? "Loading..." : "Apply Filter"}
          </button>

        </div>
        <div style={{ display: "flex", alignItems: "center", marginTop: "20px", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                marginRight: "10px", // Space between input and button
                width: "150px",
              }}
            />
            <button
              style={{
                backgroundColor: "#28a745", // Success color
                color: "#fff", // Text color
                border: "none", // No border
                borderRadius: "5px", // Rounded corners
                cursor: "pointer", // Pointer cursor
                width: "35px", // Fixed width
                height: "35px", // Fixed height to match input height
                display: "flex", // Flexbox for centering
                alignItems: "center", // Center vertically
                justifyContent: "center", // Center horizontally
                position: "relative", // Relative positioning for the icon
              }}
              onClick={handleSearch}
            >
              {/* Circle for search icon (lens) */}
              <div
                style={{
                  width: "12px", // Circle width
                  height: "12px", // Circle height
                  border: "2px solid white", // Circle color
                  borderRadius: "50%", // Makes the div circular
                  position: "absolute", // Position it inside the button
                  top: "45%", // Center vertically
                  left: "45%", // Center horizontally
                  transform: "translate(-50%, -50%)", // Adjust for exact centering
                }}
              />
              {/* Search handle */}
              <div
                style={{
                  width: "2px", // Handle width
                  height: "8px", // Handle height
                  backgroundColor: "white", // Handle color
                  position: "absolute", // Position it relative to the circle
                  top: "80%", // Adjust to position the handle just below the circle
                  left: "65%", // Move to the right side of the circle (to mirror it)
                  transform: "translate(-50%, -100%) rotate(-45deg)", // Adjust for exact positioning and angle (mirror the rotation)
                }}
              />
            </button>

          </div>

          <button
            style={{
              backgroundColor: "#007bff", // Button color
              color: "#fff", // Text color
              padding: "10px 20px", // Padding for button
              border: "none", // No border
              borderRadius: "5px", // Rounded corners
              cursor: "pointer", // Pointer cursor
            }}
            onClick={() => downloadCsv(statusPayload)}
          >
            {isLoading ? "Downloading..." : "Download"}
          </button>
        </div>

      </div>
      <div
        style={{
          overflowX: "auto",
          maxWidth: "1300px",
          maxHeight: "500px",
          marginTop: "20px",
          padding: "0 10px",
        }}
      >
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>S.No</th>
              <th style={thStyle}>Lead Number</th>
              <th style={thStyle}>Client Code</th>
              <th style={thStyle}>Client Name</th>
              <th style={thStyle}>CP Remarks</th>
              <th style={thStyle}>CP Status</th>
              <th style={thStyle}>Event Name</th>
              <th style={thStyle}>Event Date</th>
              <th style={thStyle}>Groom Name</th>
              <th style={thStyle}>Bride NAme</th>
              <th style={thStyle}>CRM Name</th>
              <th style={thStyle}>Product Lead Name</th>
              <th style={thStyle}>Team Name</th>
              <th style={thStyle}>Product Name</th>
              <th style={thStyle}>Sub Status</th>
              <th style={thStyle}>Last Assigned Date</th>
              {(name == "CLIENT CHANGES" ||
                name == "EW QUEUE"
              ) && <th style={{ ...thStyle, minWidth: "220px" }}>ETA Date</th>}
              {(name == "CLIENT CHANGES" ||
                name == "NOT APPLICABLE" ||
                name == "CLIENT REWORK" ||
                name == "ON HOLD") && <th style={{ ...thStyle, minWidth: "220px" }}>Remarks</th>}

              <th style={thStyle}>Deliverable Status</th>
              <th style={thStyle}>Data Copy Status</th>
              <th style={thStyle}>Copied Date</th>
            </tr>
          </thead>
          <tbody>
            {currentPageData && currentPageData.length > 0 ? (
              currentPageData.map((item, index) => {
                const eventName =
                  item && item.eventName && item.eventName.length > 0
                    ? item.eventName.map((m) => m).join(",")
                    : "--"
                const eventDate =
                  item && item.eventDate && item.eventDate.length > 0
                    ? item.eventDate
                      .map((m) => moment(m).format(dateFormat))
                      .join(",")
                    : "--"
                const lastAssignedDate =
                  name == "PL PENDING" && !isEmpty(item.assignCRMDate)
                    ? item.assignCRMDate
                    : name == "EW PENDING" && !isEmpty(item.assignTeamLeadDate)
                      ? item.assignTeamLeadDate
                      : name == "EW QUEUE" && !isEmpty(item.assignEmpDate)
                        ? item.assignEmpDate
                        : name == "EW INPROGRESS" && !isEmpty(item.subStatusDate)
                          ? item.subStatusDate
                          : item.processDate
                console.log(lastAssignedDate, "lastAssignedDate")
                return (
                  <>
                    <tr key={index}>
                      <td style={tdStyle}>{index + 1}</td>
                      <td style={tdStyle}>{item.leadNo}</td>
                      <td style={tdStyle}>
                        {item.clientCode ? item.clientCode : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.clientName ? item.clientName : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.cpRemarks ? item.cpRemarks : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.cpStatus ? item.cpStatus : "--"}
                      </td>
                      <td style={tdStyle}>{eventName}</td>
                      <td style={tdStyle}>{eventDate}</td>
                      <td style={tdStyle}>
                        {item.groomName ? item.groomName : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.brideName ? item.brideName : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.assignCRMEmpName ? item.assignCRMEmpName : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.assignTeamEmpName ? item.assignTeamEmpName : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.assignEmpName ? item.assignEmpName : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.productName ? item.productName : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.subStatus ? item.subStatus : "--"}
                      </td>
                      <td style={tdStyle}>
                        {!isEmpty(lastAssignedDate)
                          ? moment(lastAssignedDate).format(dateFormat)
                          : "--"}
                      </td>
                      {(name == "CLIENT CHANGES" ||
                        name == "EW QUEUE") && (
                          <td style={tdStyle}>{item.tat ? moment(item.tat).format(dateFormat) : "--"}</td>
                        )}
                      {(name == "CLIENT CHANGES" ||
                        name == "NOT APPLICABLE" ||
                        name == "CLIENT REWORK" ||
                        name == "ON HOLD") && (
                          <td style={tdStyle}>{item.remarks ? item.remarks : "--"}</td>
                        )}

                      <td style={tdStyle}>
                        {item.productioProcessStatusName
                          ? item.productioProcessStatusName
                          : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.dataCopyStatusName ? item.dataCopyStatusName : "--"}
                      </td>
                      <td style={tdStyle}>
                        {item.dataCopiedOn ? moment(item.dataCopiedOn).format(dateFormat) : "--"}
                      </td>
                    </tr>
                  </>
                )
              })
            ) : (
              <>
                <tr key={0}>
                  <td colSpan={19} style={{ ...tdStyle, textAlign: "center" }}>
                    No record found
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
        }}
      >
        {/* Showing rows information */}
        <p style={{ margin: "0", float: "left" }}>
          Showing rows {filteredData.length > 0 ? startIndex + 1 : 0} to{" "}
          {Math.min(endIndex, filteredData.length)} of {tableData.length}
        </p>
        {/* Pagination buttons */}
        <div style={{ float: "right" }}>
          <button
            style={{
              backgroundColor: "#FFFFFF",
              color: "#74788D",
              border: "1px solid #74788D",
              padding: "5px 10px",
              marginRight: "5px",
              cursor: "pointer",
            }}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Prev
          </button>
          {renderPaginationButtons()}
          <button
            style={{
              backgroundColor: "#FFFFFF",
              color: "#74788D",
              border: "1px solid #74788D",
              padding: "5px 10px",
              marginRight: "5px",
              cursor: "pointer",
            }}
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>

  )
}

ProductTableComponent.propTypes = {
  data: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  statusPayload: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  dateFormat: PropTypes.string,
}

export default ProductTableComponent
